import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';

import { TicketUpdateForm } from './common/TicketForms';
import ConfirmationModal from './common/ConfirmationModal';


function ChatMessage({followUp}){

  //console.log(followUp);

  let attachment = false;
  if (followUp.attachments.length > 0){
    attachment = followUp.attachments[0]
  }

  const usertype = followUp.user.userprofile.usertype;
  const isLab = usertype === 'LAB';
  const isStaff = usertype === 'SPECIALIST';

  if (followUp.new_status === 'CLOSED') {
    return (
      <>
        <div className="alert alert-secondary text-center" role="alert">
          <p className="mb-0">Обращение закрыто</p>
        </div>
        <div className="d-grid d-md-flex justify-content-between">
          {isLab && <span className='message-date'>Пользователь:</span>}
          {isStaff && <span className='message-date'>Специалист АСНП:</span>}
          <span className='message-date'>{followUp.date}</span>
        </div>
      </>
    );
  }

  return (
    <>
      {isLab &&
        <div className="alert alert-primary" role="alert">
          <p>{followUp.comment}</p>
          {attachment ? <a href={attachment.file} class="alert-link">приложенный файл</a> : <></> }
        </div>
      }
      {isStaff &&
        <div className="alert alert-info" role="alert">
          <p>{followUp.comment}</p>
          {attachment ? <a href={attachment.file} class="alert-link">приложенный файл</a> : <></> }
        </div>
      }     
      <div className="d-grid d-md-flex justify-content-between">
        {isLab && <span className='message-date'>Пользователь:</span>}
        {isStaff && <span className='message-date'>Специалист АСНП:</span>}
        <span className='message-date'>{followUp.date}</span>
      </div>

    </>
  );
}


function TicketActions({ticket, apiPath}) {
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();
  const [actionError, setActionError] = useState(false);

  const isClosed = ticket.status === 'CLOSED';
  const receivedFromLab = Boolean(
    ticket?.theme && ticket.lab?.username && ticket.creator?.username === ticket.lab.username
  );
  const alreadySent = Boolean(ticket.documents_workflow_sent_at);
  const canClose = Boolean(ticket.id) && !isClosed;
  const canSend = Boolean(ticket.id) && receivedFromLab && !alreadySent;

  function runOperation(operation, fallback) {
    axios_api.put(api_url + apiPath + ticket.id, { operation }, {
      headers: {"Authorization": token}
    }).then(
      () => {
        navigate(0);
      },
      (error) => {
        setActionError(error.response?.data || fallback);
      }
    );
  }

  if (!ticket.id) {
    return null;
  }

  return (
    <>
      {canClose &&
        <ConfirmationModal
          modalId="confirmTicketCloseModal"
          headerText="Обращение"
          messageText={[
            "Вы уверены, что хотите закрыть обращение?",
            "После этого в него нельзя будет добавить сообщения"
          ]}
          confirmButtonText="Закрыть обращение"
          Action={() => runOperation('close', 'Не удалось закрыть обращение')}
        />
      }
      {canSend &&
        <ConfirmationModal
          modalId="confirmDocumentsWorkflowModal"
          headerText="Документооборот"
          messageText={[
            "Направить копию обращения в документооборот?",
            "Повторно отправить его будет нельзя"
          ]}
          confirmButtonText="Направить"
          Action={() => runOperation('send-to-documents-workflow', 'Не удалось направить обращение в документооборот')}
        />
      }
      {(canClose || canSend) &&
      <div className="dropdown mb-4">
        <button
          className="btn lk-button dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Действия
        </button>
        <ul className="dropdown-menu">
          <li>
            <button
              type="button"
              className="dropdown-item"
              disabled={!canClose}
              data-bs-toggle={canClose ? "modal" : undefined}
              data-bs-target={canClose ? "#confirmTicketCloseModal" : undefined}
            >
              Закрыть обращение
            </button>
          </li>
          <li>
            <button
              type="button"
              className="dropdown-item"
              disabled={!canSend}
              data-bs-toggle={canSend ? "modal" : undefined}
              data-bs-target={canSend ? "#confirmDocumentsWorkflowModal" : undefined}
            >
              Направить в документооборот
            </button>
          </li>
        </ul>
      </div>
      }
      {alreadySent &&
        <p className="text-secondary mb-4">
          Направлено в документооборот {ticket.documents_workflow_sent_at}
        </p>
      }
      {actionError &&
        <p className="text-danger mt-3">
          {typeof actionError === 'string' ? actionError : 'Не удалось выполнить действие'}
        </p>
      }
    </>
  );
}


export default function TicketUpdate({selectedYear}){
  const[notFound, setNotFound] = useState(false);
  const[ticket, setTicket] = useState([]);
  const[updateNeeded, setUpdateNeeded] = useState(false);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  let { ticketId } = useParams();
  const isClosed = ticket.status === 'CLOSED';

  React.useEffect(() => {

    let apiReturnedTicket = axios_api.get(api_url + '/manage_ticket_tasks/' + ticketId, {
      headers: {"Authorization": token}
    });

    apiReturnedTicket.then(
      (result) => {
        //console.log(result.data);
        setTicket(result.data);
      },
      (error) => {
        console.log(error)
        if (error.status === 404) {
          setNotFound(true)
        }
      }
    );

  }, []);

  //function UpdateChat() {
  //  setUpdateNeeded(!updateNeeded);
  //  alert(1)
  //}


  let rows = [];
  for (let i in ticket.follow_ups) {
    rows.push(
      <>
        <ChatMessage 
          key={i} 
          followUp={ticket.follow_ups[i]} 
        />
      </>
    ); 
  }

  return (
    <>
      {notFound === false ?
        <>  
          <div className="row">
            <h3 className="m-3">Обращение № {ticket.id} - лаборатория {ticket.lab?.username || ticket.creator?.username}</h3>
            {ticket.theme?.theme_name &&
              <h6 className="ms-3 mt-0">Тема - {ticket.theme.theme_name}</h6>
            }
          </div>
          {isClosed &&
            <p className='ms-3 mb-0 text-secondary'>Обращение закрыто{ticket.closed_at ? ` ${ticket.closed_at}` : ''}</p>
          }

            
          <div className='row mt-2 m-3'>
            <div className='col-6 ps-0'>
              <div className='chat-fade'>
                <div className='px-5 py-4 vh-75 chat-background overflow-scroll'>
                  {rows}
                  <div className="d-grid d-md-flex justify-content-center">

                    <span className='mt-4 message-date'>-- начало переписки --</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-6 ps-5'>
              <TicketActions ticket={ticket} apiPath="/manage_ticket_tasks/" />
              {isClosed ?
                <p className="text-secondary">В закрытое обращение нельзя добавить сообщение</p>
              :
                <div className="mt-5">
                  <TicketUpdateForm
                    ticketId={ticket.id} 
                  />
                </div>
              }
            </div>                     
          </div>
        </>
      :
        <div className="row">
          <h3 className="m-3">Обращение не найдено</h3>
        </div>
      }
    </>
  );
}
